define('lib/MouseAnim',[], function () {

    "use strict";

    var mousePos = {x: 0, y: 0};

    var mouseSrnPos = {x: 0, y: 0};

    var scrolled = {x: 0, y: 0};

    var intvl = 0;

    var paused = 0;

    var insts = [];

    var screenSize = {
        w: window.innerWidth,
        h: window.innerHeight
    };

    var smoothXY = function (old, current) {
        /*
        return {
            x: old.x + Math.round( (current.x - old.x) / 4 ),
            y: old.y + Math.round( (current.y - old.y) / 4 )
        };
        */
        return current;
    };

    var onMousemove = function (event) {
        mouseSrnPos = smoothXY(mouseSrnPos, {
            x: event.clientX,
            y: event.clientY
        });

        changePos();
    };

    var onScroll = function () {
        if (typeof window.scrollX !== 'undefined') {
            scrolled = {
                x: window.scrollX,
                y: window.scrollY
            };
        } else {
            scrolled = {
                x: window.pageXOffset,
                y: window.pageYOffset
            };
        }
        changePos();
    };

    var onResize = function () {
        onScroll();
        mouseSrnPos = {
            x: mouseSrnPos.x * window.innerWidth / screenSize.w,
            y: mouseSrnPos.y * window.innerHeight / screenSize.h
        };
        screenSize = {
            w: window.innerWidth,
            h: window.innerHeight
        };
        changePos();
    };

    var changePos = function () {
        mousePos = {
            x: mouseSrnPos.x + scrolled.x,
            y: mouseSrnPos.y + scrolled.y
        };
        posChanged = 1;
    };

    var posChanged = 0;

    var frame = function () {
        if (posChanged) {
            insts.forEach(function (inst) {
                inst.anims.forEach(function (anim) {
                    inst.render(anim);
                });
            });
        }

        posChanged = 0;

        if (window.requestAnimationFrame && !paused) {
            window.requestAnimationFrame(frame);
        }
    };

    var MouseAnim = function () {
        insts.push(this);
        this.anims = [];

        if (insts.length <= 1) {
            // Events to track mouse position
            window.addEventListener('scroll', onScroll);
            window.addEventListener('mousemove', onMousemove);
            window.addEventListener('resize', onResize);

            // start the rendering loop
            paused = 0;
            frame();

            // fallback for ie9
            if (!window.requestAnimationFrame) {
                intvl = window.setInterval(frame, 16); // 60 fps
            }
        }
    };

    var add = function () {
        var anim;

        // force to rerender
        changePos();

        // callback function
        if (typeof arguments[0] === 'function') {
            anim = arguments[0];
        }

        this.anims.push(anim);
    };

    var render = function (anim) {
        if (typeof anim === 'function') {
            anim({
                mousePos: mousePos,
                mouseSrnPos: mouseSrnPos,
                scrolled: scrolled
            });
        }
    };

    var destroy = function () {
        // remove instance
        this.destroyed = 1;
        insts = insts.filter(function (inst) {
            return !inst.destroyed;
        });


        if (!insts.length) {
            // remove events
            window.removeEventListener('scroll', onScroll);
            window.removeEventListener('mousemove', onMousemove);
            window.removeEventListener('resize', onResize);

            // stop rendering loop
            paused = 1;
            if (intvl) {
                window.clearInterval(intvl);
            }
        }
    };

    MouseAnim.prototype = {
        add: add,
        render: render,
        destroy: destroy
    };

    return MouseAnim;

});
